export default __webpack_public_path__ + "static/media/view-symptoms.24eff0a7.svg";